import { IDateBoxOptions } from 'devextreme-react/date-box';
import { iButtonDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import { iCheckBoxDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/CheckBox/CheckBox';
import { iDataGridDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/DataGrid/DataGrid';
import { iFormDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Form/Form';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';
import { nameof } from 'ts-simple-nameof';
import { OrderReturnStepData } from '../OrderReturnStepData';
import { OrderReturnStepPayloadItemData } from './OrderReturnStepForm';

export const OrderReturnStepFormFormId = 'OrderReturnStepForm.form';
const OrderReturnStepFormFormOptions: iFormDisplayOptions = {
    id: OrderReturnStepFormFormId,
    validationGroup: 'orderReturnStepForm',
    labelLocation: 'left',
    showValidationSummary: true,
    items: [
        {
            dataField: nameof<OrderReturnStepData>((c) => c.location!.logisticUnit),
            editorType: 'dxSelectBox',
            itemType: 'simple',
            label: {
                text: 't~OrderReturnStepForm:location',
            },
            editorOptions: {
                displayExpr: 'name',
                dataSource: 'ds~originLocationsDataSource',
                //itemTemplate: "LogisticUnitSimpleTextItem"
            },
            isRequired: true,
            validationRules: [
                {
                    type: 'required',
                    message: 't~OrderReturnStepForm:validation.logisticUnit.required',
                },
            ],
        },
        {
            dataField: nameof<OrderReturnStepData>((c) => c.plannedStartDate),
            editorType: 'dxDateBox',

            //template: 'DateBoxItem', <- nie pamiętam, czemu był template, bez template działa
            itemType: 'simple',
            label: {
                text: 't~OrderReturnStepForm:plannedStartDate',
            },
            isRequired: true,
            editorOptions: {
                dateOutOfRangeMessage: 't~OrderReturnStepForm:dateOutOfRange',
                type: 'datetime',
                acceptCustomValue: false,
                openOnFieldClick: true,
                defaultValue: 'v~returnStepMinPlannedStartDate',
                min: 'v~returnStepMinPlannedStartDate',
            } as IDateBoxOptions,
            validationRules: [
                {
                    type: 'required',
                    message: 't~OrderReturnStepForm:validation.plannedStartDate.required',
                },
                {
                    type: 'range',
                    message: 't~OrderReturnStepForm:validation.plannedStartDate.outOfRange',
                    min: 'v~returnStepMinPlannedStartDate' as any,
                },
            ],
        },
    ],
};
propsStore.insert(OrderReturnStepFormFormOptions);

export const orderStepsReturnRemoveStepButtonId = 'OrderReturnStepForm.removeStepButton';
const orderStepsReturnRemoveStepButtonOptions: iButtonDisplayOptions = {
    id: orderStepsReturnRemoveStepButtonId,
    //
    width: '200px',
    type: 'danger',
    stylingMode: 'text',
    //
    text: 't~OrderReturnStepForm:removeStepButton',
};
propsStore.insert(orderStepsReturnRemoveStepButtonOptions);

export const orderStepsReturnAddCarrierButtonId = 'OrderReturnStepForm.AddCarrierButton';
const orderStepsReturnAddCarrierButtonOptions: iButtonDisplayOptions = {
    id: orderStepsReturnAddCarrierButtonId,
    //
    icon: 'plus',
    width: '200px',
    type: 'success',
    stylingMode: 'outlined',
    //
    text: 't~OrderReturnStepForm:addCarrierButton',
    validationGroup: 'orderReturnStepForm',
    useSubmitBehavior: true,
};
propsStore.insert(orderStepsReturnAddCarrierButtonOptions);

export const orderStepsReturnSaveStepButtonId = 'OrderReturnStepForm.SaveStepButton';
const orderStepsReturnSaveStepButtonOptions: iButtonDisplayOptions = {
    id: orderStepsReturnSaveStepButtonId,
    //
    icon: 'plus',
    width: '200px',
    type: 'success',
    //
    text: 't~OrderReturnStepForm:saveStepButton',
};
propsStore.insert(orderStepsReturnSaveStepButtonOptions);

export const orderStepsReturnPayloadGridId = 'OrderReturnStepForm.PayloadGrid';
const orderStepsReturnPayloadGridOptions: iDataGridDisplayOptions = {
    id: orderStepsReturnPayloadGridId,
    //
    columnAutoWidth: true,
    showBorders: false,
    width: '100%',
    height: '100%',
    //
    columns: [
        {
            dataField: nameof<OrderReturnStepPayloadItemData>((c) => c.product),
            editCellTemplate: 'ProductInfoEditColumn',
            width: '50%',
            cellTemplate: 'ProductInfoColumn',
            caption: 't~OrderReturnStepForm:column.product',
            // @ts-ignore
            showEditorAlways: 'v~isNotReadOnly',
        },
        {
            dataField: nameof<OrderReturnStepPayloadItemData>((c) => c.carrierType),
            width: '50%',
            editCellTemplate: 'CarrierTypeModelEditColumn',
            cellTemplate: 'CarrierTypeModelSimpleTextColumn',
            caption: 't~OrderReturnStepForm:column.carrierType',
            // @ts-ignore
            showEditorAlways: 'v~isNotReadOnly',
            validationRules: [
                {
                    type: 'required',
                    message: 't~OrderReturnStepForm:validation.carrierType.required',
                },
            ],
        },
        {
            dataField: nameof<OrderReturnStepPayloadItemData>((c) => c.maximumAllowedStacks),
            allowEditing: true,
            headerCellTemplate: 'AllowedStacksHeader',
            width: 150,
            editCellTemplate: 'NumberBoxEditCell',
            // @ts-ignore
            showEditorAlways: 'v~isNotReadOnly',
            validationRules: [
                {
                    type: 'range',
                    min: 1,
                    max: 6,
                    message: 't~OrderReturnStepForm:validation.maximumAllowedStacks.outOfRange',
                },
            ],
            editorOptions: {
                showClearButton: false,
                showSpinButtons: true,
                min: 1,
                max: 6,
            },
        },
        {
            dataField: nameof<OrderReturnStepPayloadItemData>((c) => c.count),
            allowEditing: true,
            width: 80,
            editCellTemplate: 'NumberBoxEditCell',
            // @ts-ignore
            showEditorAlways: 'v~isNotReadOnly',
            caption: 't~OrderReturnStepForm:column.count',
            validationRules: [
                {
                    type: 'range',
                    min: 1,
                    message: 't~OrderReturnStepForm:validation.count.required',
                },
            ],
            editorOptions: {
                showClearButton: false,
                showSpinButtons: true,
                min: 1,
            },
        },
    ],
};
propsStore.insert(orderStepsReturnPayloadGridOptions);

export const orderStepsReturnShowExternalLocationsCheckBoxId =
    'OrderReturnStepForm.showExternalLocationsCheckBox';
const orderStepsReturnShowExternalLocationsCheckBoxOptions: iCheckBoxDisplayOptions = {
    id: orderStepsReturnShowExternalLocationsCheckBoxId,
    text: 't~OrderReturnStepForm:showExternalLocations',
};
propsStore.insert(orderStepsReturnShowExternalLocationsCheckBoxOptions);
